import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MobileVerificationModalComponent } from './mobile-verification-modal.component';
import { ButtonModule, InputsModule } from '@xref/xref-lib';
import { LoaderModule } from '../loader/loader.module';

@NgModule({
  declarations: [MobileVerificationModalComponent],
  imports: [
    CommonModule,
    FormsModule,
    ButtonModule,
    InputsModule,
    LoaderModule
  ],
  exports: [MobileVerificationModalComponent]
})
export class MobileVerificationModalModule {
}


